import { useWatch } from 'react-hook-form';

import { FormValues } from '../../../../customFormEditPage.types';

import { FormFieldRow } from './components/formFieldRow';

type Props = {
  onRowMoved: (fromIndex: number, toIndex: number) => void;
  onDelete: (index: number) => void;
};

export function FormFieldRows({ onRowMoved, onDelete }: Props): JSX.Element {
  const fields = useWatch<FormValues, 'formFields'>({ name: 'formFields' });

  return (
    <>
      {fields?.map((field, index) => (
        <FormFieldRow
          key={`${field.id}-${index}`}
          field={field}
          index={index}
          onOrderChange={onRowMoved}
          onDelete={onDelete}
        />
      ))}
    </>
  );
}
